export const userTypeValues = [{ value: "Administrator" }, { value: "TRE" }];
export const userLevelValues = [{ value: "Admin" }, { value: "Staff" }];
export const userTypeValuesAll = [
  { value: "Administrator" },
  { value: "TRE" },
  { value: "All" },
];

const options = {
  userTypeValues,
  userLevelValues,
  userTypeValuesAll,
};

export default options;
